module.exports = {
  api_server: 'https://api.caliby.com',
  //api_server: 'http://localhost:4567',
}